import Header from '../../components/Header';
import Footer from '../../components/Footer';

export default function TermsPrivacyPage() {
  return (
    <div>
      <Header/>
      <main
        data-bg-type='white'
        className='wrapper my-[100px] lg:my-[160px]'
      >
        <h1 className='text-title3 font-bold lg:text-display3 text-center'>개인정보 처리 방침</h1>

        <div className='flex flex-col gap-y-[30px] mt-[120px]'>
          <div>
            <h2 className='font-bold lg:text-heading3'>1. 개인정보 처리 방침이란?</h2>
            <p className='mt-[10px]'>
              주식회사 <span className="font-semibold">모듈링크</span>(이하 "회사")는 이용자의 동의를 기반으로 개인정보를 수집·이용 및 제공하고 있으며, 이용자의
              권리(개인정보 자기 결정권)를 적극적으로 보장합니다.
              <br/>
              회사는 정보통신 서비스 제공자가 준수하여야 하는 대한민국의 관계 법령 및 개인정보보호 규정, 가이드라인을 준수하고 있습니다.
              <br/>
              “개인정보 처리방침”이란 이용자의 소중한 개인정보를 보호함으로써 이용자가 안심하고 서비스를 이용할 수 있도록 회사가 준수해야 할 지침을 의미합니다.
              <br/>
              본 개인정보 처리방침은 회사가 제공하는 <span className='font-semibold'>모듈링크 계정 기반의 서비스</span>(이하 ‘서비스'라 함)에 적용됩니다.
            </p>
          </div>

          <div>
            <h2 className='font-bold lg:text-heading3'>2. 개인정보 수집</h2>
            <p className="mt-[10px]">
              서비스 제공을 위한 필요 최소한의 개인정보를 수집하고 있습니다.
              <br/>
              회원 가입 시 또는 서비스 이용 과정에서 홈페이지 또는 개별 애플리케이션이나 프로그램 등을 통해 아래와 같은 서비스 제공을 위해 필요한 최소한의 개인정보를 수집하고 있습니다.
              <br/>
              <br/>
              <ul className="[&>li>ul]:list-disc [&>li>ul]:pl-[50px] [&>li>ul]:py-[10px]">
                <li className="font-semibold">[모듈링크 계정]</li>
                <li>
                  <ul>
                    <li>필수: SNS 아이디, 이메일 주소, 회원 가입일, 제품 고유번호, 위치정보 데이터</li>
                    <li>선택: 혈액형, 응급구조 시 참고사항, 가입 보험사 정보</li>
                  </ul>
                </li>
                <li className="font-semibold">[본인인증 후 서비스 이용 시]</li>
                <li>
                  <ul>
                    <li>필수: 이름, 성별, 생년월일, 휴대전화 번호, 통신사업자, 내/외국인 여부, 암호화된 이용자 확인 값(CI), 중복가입 확인 정보(DI), 서비스 이용 내역, 서비스 내
                      구매 및 결제 내역, 휴대전화 위치정보, 긴급상황 호출 위치정보
                    </li>
                  </ul>
                </li>
                <li className="font-semibold">[법정대리인 동의 후 서비스 이용 시]</li>
                <li>
                  <ul>
                    <li>필수: 이름, 성별, 생년월일, 휴대전화 번호, 통신사업자, 내/외국인 여부, 암호화된 이용자 확인 값(CI), 중복가입 확인 정보(DI), 서비스 이용 내역, 서비스 내
                      구매 및 결제 내역, 휴대전화 위치정보, 긴급상황 호출 위치정보
                    </li>
                  </ul>
                </li>
                <li className="font-semibold">[유료서비스 이용 시]</li>
                <li>
                  <ul>
                    <li>신용카드 결제 시: 카드번호(일부), 카드사명 등</li>
                    <li>휴대전화 번호 결제 시: 휴대전화 번호, 결제승인번호 등</li>
                  </ul>
                </li>
                <li className="font-semibold">[환불 처리 시]</li>
                <li>
                  <ul>
                    <li>계좌은행, 계좌번호, 예금주명, 이메일</li>
                  </ul>
                </li>
                <li className="font-semibold">[현금영수증 발행 시]</li>
                <li>
                  <ul>
                    <li>휴대전화 번호, 현금영수증 카드번호</li>
                  </ul>
                </li>
              </ul>


              일부 서비스에서는 특화된 여러 기능을 제공하기 위해 ‘모듈링크 계정’에서 공통으로 수집하는 정보 이외에 이용자에게 동의를 받고 추가적인 개인정보를 수집할 수 있습니다.
              <br/>
              개인정보를 수집하는 방법은 다음과 같습니다.
              <ul className='list-disc pl-[50px] py-[10px]'>
                <li>회원 가입 및 서비스 이용 과정에서 이용자가 개인정보 수집에 대해 동의를 하고 직접 정보를 입력하는 경우</li>
                <li>제휴 서비스 또는 단체 등으로부터 개인정보를 제공받은 경우</li>
                <li>고객센터를 통한 상담 과정에서 웹페이지, 메일, 팩스, 전화 등을 통해 고객에게 제공받은 경우</li>
                <li>온·오프라인에서 진행되는 이벤트/행사 등 참여</li>
              </ul>
              서비스 이용 과정에서 자동으로 수집되는 정보
              <ul className='list-disc pl-[50px] py-[10px]'>
                <li>단말기 정보(OS, 화면사이즈, 디바이스 ID, 핸드폰 기종 등), IP 주소, 쿠키, 방문일시, 부정 이용기록, 서비스 이용기록 등</li>
              </ul>

            </p>
          </div>
          <div>
            <h2 className='font-bold lg:text-heading3'>3. 개인정보 이용</h2>
            <p className="mt-[10px]">
              회사는 수집한 개인정보를 아래와 같은 목적으로 이용합니다.
              <ul className='list-disc pl-[50px] py-[10px]'>
                <li>회원 식별 및 가입 의사 확인, 본인 및 연령 확인, 부정 이용 방지</li>
                <li>법정 대리인 동의 확인, 권리 행사 시 본인 확인</li>
                <li>서비스 제공 및 개선, 문의사항 처리, 공지사항 전달</li>
                <li>유료 서비스 결제 및 요금 정산</li>
                <li>부정행위 방지 및 제재</li>
                <li>맞춤형 콘텐츠 추천 및 마케팅</li>
                <li>사고 위험 예측 정확도 향상, 개인화 서비스 제공</li>
                <li>통계 분석 및 서비스 개선</li>
                <li>응급상황 시 긴급 출동 및 응급 신고 대행 서비스 제공</li>
              </ul>
            </p>
          </div>
          <div>
            <h2 className="font-bold lg:text-heading3">4. 개인정보 제공</h2>
            <p className="mt-[10px]">
              회사는 법령에 근거하거나 이용자의 동의가 있는 경우를 제외하고는 개인정보를 제3자에게 제공하지 않습니다.
              <br/>
              서비스 제공 및 외부 연계 시, 이용자의 사전 동의 하에 제휴사 등 제3자에게 개인정보를 제공할 수 있습니다.
              <br/>
              또한, 서비스 제공을 위해 외부 업체에 일부 업무를 위탁할 수 있으며, 수탁업체가 관련 법령을 준수하도록 관리·감독합니다.
            </p>
          </div>
          <div>
            <h2 className='font-bold lg:text-heading3'>5. 개인정보 파기</h2>
            <p className="mt-[10px]">
              개인정보는 수집 및 이용 목적이 달성된 후 지체 없이 파기합니다.
              <ul className='list-disc pl-[50px] py-[10px]'>
                <li>전자적 파일: 복구 불가능한 방식으로 안전하게 삭제</li>
                <li>인쇄물 등: 분쇄 또는 소각</li>
              </ul>
              <span className='font-semibold'>내부 방침에 따라 보관 후 파기하는 정보</span>
              <ul className='list-disc pl-[50px] py-[10px]'>
                <li>탈퇴 후 최대 1년간 보관: 모듈링크 계정, 탈퇴 이메일 주소, 부정 이용기록</li>
                <li>개인정보 유효기간제: 1년간 미이용 시 별도 분리 보관 후 4년 뒤 파기</li>
              </ul>
              <span className='font-semibold'>법령에 따른 보관 기간 예시</span>
              <ul className='list-disc pl-[50px] py-[10px]'>
                <li>전자상거래법: 최대 5년</li>
                <li>국세기본법: 5년</li>
                <li>전자금융거래법: 5년</li>
                <li>통신비밀보호법: 3개월</li>
              </ul>
            </p>
          </div>
          <div>
            <h2 className='font-bold lg:text-heading3'>6. 기타 사항</h2>
            <p>
              이용자(또는 법정대리인)는 언제든지 자신의 개인정보를 조회, 수정하거나, 수집 및 이용 동의 철회 또는 회원 탈퇴를 요청할 수 있습니다.
              <br/>
              쿠키를 통한 맞춤형 정보 제공 및 쿠키 차단 옵션 제공
              <br/>

              <span className="font-bold">모듈링크는 개인정보 보호를 위해 다음과 같은 조치를 취하고 있습니다.</span>
              <ul className="list-disc pl-[50px] py-[10px]">
                <li>해킹, 바이러스 방지를 위한 보안 시스템 적용</li>
                <li>개인정보 접근 권한 최소화</li>
                <li>정기적인 직원 교육 실시</li>
              </ul>

              <span className="font-bold">[개인정보 처리의 목적 및 처리 근거]</span>
              <br/>
              회사는 아래의 근거에 따라 개인정보를 처리합니다.
              <ul className="list-disc pl-[50px] py-[10px]">
                <li>정보 주체의 동의</li>
                <li>계약 체결 및 이행</li>
                <li>법적 의무 준수</li>
                <li>정보 주체의 생명·신체 보호 등 중대한 이익 보호</li>
                <li>회사의 정당한 이익(단, 이용자의 권리보다 우선하지 않는 경우)</li>
              </ul>

              <span className="font-bold">[문의처]</span>
              <br/>
              개인정보 관련 문의 및 요청은 아래로 연락 주시기 바랍니다.
              <br/>
              이메일: <span className='font-semibold'>help@module-link.com</span>
              <br/>
              또한, 외부 기관을 통한 신고 및 상담이 가능합니다.
              <ul className="list-disc pl-[50px] py-[10px]">
                <li>개인정보 침해 신고센터: 118 / <a className='text-blue-600 underline'
                                           href='https://privacy.kisa.or.kr'>https://privacy.kisa.or.kr</a></li>
                <li>대검찰청 사이버수사과: 1301 / <a className='text-blue-600 underline'
                                           href='https://cybercid.spo.go.kr'>https://cybercid.spo.go.kr</a></li>
                <li>경찰청 사이버안전국: 182 / <a className='text-blue-600 underline'
                                         href='https://cyberbureau.police.go.kr'>https://cyberbureau.police.go.kr</a>
                </li>
              </ul>

              <span className="font-bold">[변경 고지]</span>
              <br/>
              본 방침은 관련 법령 및 서비스 변경에 따라 수정될 수 있으며, 변경 시 웹사이트 공지 사항을 통해 안내드리며, 주요 변경 사항은 시행 최소 7일 전에 사전 공지합니다.
              <br/>
              주식회사 모듈링크는 이용자의 소중한 정보를 보호하기 위해 항상 최선을 다하겠습니다.
            </p>
          </div>
        </div>
      </main>
      <Footer/>
    </div>
  )
}